import React, { useEffect } from "react";
import "./styles.css";

const Toast = ({ display, message, onClose }) => {
  useEffect(() => {
    let timer;
    if (display) {
      timer = setTimeout(() => {
        onClose();
      }, Math.min(2000 + 100 * parseInt(message.length),20000));
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [display, onClose]);

  return (
    <div className={`toast ${display ? "show" : ""}`}>
      <p>{`${message}`}</p>
    </div>
  );
};

export default Toast;
